<template>
  <div>
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>
    <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else>
        <cross-entities-links entityCode='procedure' :entityId="id"/>
        <div class="entity-card">
          <div class="flex flex-row justify-between pa3 pa4-l">
            <div>
              <h1 class="db f3 f3-l ttu ma0 pa0 fw5">{{ bid_directions[procedure.direction].name }}</h1>
              <span class="db mt2">{{ procedure.id }}</span>
            </div>
            <div>
              <span class="entity-status">
                {{ statuses[procedure.status].name }}
              </span>
            </div>
          </div>
          <entity-menu :items="menu" v-model="menuSelected"/>
          <keep-alive>
            <component :is="detailsComponent" :proc='procedure' class="bg-white"/>
          </keep-alive>
        </div>
      </div>
    </request>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import Request from '@/components/Request.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import CrossEntitiesLinks from '@/components/common/CrossEntitiesLinks.vue'
import EntityMenu from '@/components/common/EntityMenu.vue'
import CardDetails from '@/components/procedures/CardDetails.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavBackToList,
    Request,
    ContentSpinner,
    CrossEntitiesLinks,
    EntityMenu,
    CardDetails
  },
  props: ['id'],
  data () {
    return {
      request: {
        method: 'getProcedureDetails',
        params: {
          procId: this.id
        }
      },
      response: null,
      menu: [],
      menuSelected: 0
    }
  },
  computed: {
    ...mapGetters('procedure', ['bid_directions', 'statuses', 'makeProcedure']),
    procedure () {
      if (this.response.procedure) {
        const [procedure] = this.makeProcedure({ procedures: [this.response.procedure] })
        return procedure
      } else {
        return null
      }
    },
    detailsComponent () {
      return 'CardDetails'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
